import { getLocalData, insertLocalData } from "../local/local.action";
import { TYPES } from "./onboard.type";
// ~~~~~~~~~~` action `~~~~~~~~~~
export const getOnboardFirst = (data) => (dispatch) => {
  const isOnboard = getLocalData("isOnboard") || false;
  setOnboardHasSuccess(dispatch, isOnboard);
};

export const setOnboardAlready = () => (dispatch) => {
  setOnboardHasSuccess(dispatch, true);
  insertLocalData("isOnboard", true);
};

// ~~~~~~~~~~` dispatch `~~~~~~~~~~
const setOnboardHasSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_ONBOARD_HAS,
    payload: data,
  });
};
